define('models/composer/forms/questionTemplates',[
    'lib/knockout',
    'lib/lodash4',
    'models/composer/forms/QuestionType',
    'extensions/i18n/knockout.i18n'
], function(ko, _, QuestionType) {
    "use strict";

    var templates;

    function questionTemplates() {
        if(templates) {
            return templates;
        }
        templates = {
            multipleChoice: {
                name: ko.i18n.renderString('composer.evaluations.questionType.multipleChoice'),
                data: {
                    type: QuestionType.multipleChoice
                }
            },

            yesNo: {
                name: ko.i18n.renderString('composer.evaluations.questionType.yesNo'),
                data: {
                    type: QuestionType.multipleChoice,
                    answerOptions: [
                        {  //YES
                            text: ko.i18n.renderString('composer.evaluations.questionType.yesNo.yes'),
                            value: 1
                        },
                        {  //NO
                            text: ko.i18n.renderString('composer.evaluations.questionType.yesNo.no'),
                            value: 0
                        }
                    ]
                }
            },

            range: {
                name: ko.i18n.renderString('composer.evaluations.questionType.range'),
                answerCount: 5, //Referenced in test case
                data: {
                    type: QuestionType.multipleChoice,
                    //answerOptions added below
                }
            }
        };

        //Add the answer options to the range question
        templates.range.data.answerOptions = _.map(_.range(templates.range.answerCount), function (index) {
            return {
                text: (index+1)+"",
                value: index+1
            };
        });

        templates.all = [templates.multipleChoice, templates.yesNo, templates.range];

        _.each(templates.all, function (template) {
            template.isDefault  = true;
            //builtin templates default to favorites
            template.isFavorite = template.isFavorite || true;
        });

        return templates;
    }

    return questionTemplates;
});

